import { useLocation } from 'react-router-dom'
import { AppointmentParameters, AppointmentRescheduleReason } from '../../constants'

type AppointmentLocationState = Record<Exclude<AppointmentParameters, 'duration_in_minutes' | 'resource_id' | 'shop_gid'>, string> & {
  [AppointmentParameters.DURATION_IN_MINUTES]: number
  [AppointmentParameters.SHOP_GID]?: string
  resource_ids?: string[]
}

type AppointmentRescheduleLocationState = AppointmentLocationState & {
  description?: string
  reason: AppointmentRescheduleReason
}

const useAppointmentLocationState = (): AppointmentLocationState => {
  const { state } = useLocation()

  return (state ?? {}) as AppointmentLocationState
}

export type { AppointmentLocationState, AppointmentRescheduleLocationState }
export { useAppointmentLocationState }
